export interface EndpointErrorResponse {
    errorCode: string;
}

export enum EndpointErrorCode {
    AuthTokenExpired = 'SJ403',
    DocumentNumberMismatchWithSection1 = 'ERR7024'
}



// WEBPACK FOOTER //
// ./src/dtos/endpoint-error.ts